const initialState = {
  paidForm: {
    insured: "",
    companyName: "",
    invoiceNumber: "",
    placingSlipNo: "",
    productCode: "",
    minSumInsured: "",
    maxSumInsured: "",
    minPremium: "",
    maxPremium: "",
    minPolicyIssueDate: "",
    maxPolicyIssueDate: "",
    minInvoiceIssueDate: "",
    maxInvoiceIssueDate: "",
    minSchedulePaymentDate: "",
    maxSchedulePaymentDate: "",
    minPaymentDate: "",
    maxPaymentDate: "",
    certificateNumber: "",
  },
};

const paidReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_PAID_FORM":
      return {
        ...state,
        paidForm: action.payload,
      };
    default:
      return state;
  }
};

export default paidReducer;
